import {UserErrorsFactory} from '../Errors/factory.js'
import ContactResponseValueObject from './ContactResponseValueObject.js'
import {ContactTokenUserValueObject} from './ContactTokenUserValueObject.js'
import {LeadHitUserValueObject} from './LeadHitUserValueObject.js'
import {PhoneVerificationStatusUserValueObject} from './PhoneVerificationStatusUserValueObject.js'
import {SubscriptionsUserValueObject} from './SubscriptionsUserValueObject.js'
import {UserExistsValueObject} from './UserExistsValueObject.js'
import UserTakeoutLinkValueObject from './UserTakeoutLinkValueObject.js'
import UserTakeoutListValueObject from './UserTakeoutListValueObject.js'

export default class UserValueObjectsFactory {
  static userTakeoutListValueObjectFactory = rawEntity => new UserTakeoutListValueObject(rawEntity)

  static userTakeoutLinkValueObjectFactory = rawEntity => new UserTakeoutLinkValueObject(rawEntity)

  static contactResponseValueObjectFactory = data => new ContactResponseValueObject(data)

  static contactTokenUserValueObjectFactory = ({contactToken}) => new ContactTokenUserValueObject({contactToken})

  static leadHitUserValueObject = ({adId, contractId, leadType, config}) => {
    LeadHitUserValueObject.validate({
      adId,
      contractId,
      leadType,
      config,
      errorFactory: UserErrorsFactory.leadHitUserError
    })

    return new LeadHitUserValueObject({
      adId,
      contractId,
      leadType
    })
  }

  static userExistsValueObjectFactory = ({userExists}) => new UserExistsValueObject({userExists})

  static phoneVerificationStatusUserValueObject = ({isVerified}) =>
    new PhoneVerificationStatusUserValueObject({isVerified})

  static subscriptionsUserValueObject = ({email, subscriptions}) =>
    new SubscriptionsUserValueObject({email, subscriptions})
}
